import {
  PRIMARY_INDUSTRIES,
  PrimaryIndustrySlug,
} from '@/constants/industries';
import { find } from 'lodash';
import { getReadableCountry } from '@/utilities/markets';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';
import { pluralise } from '@/utilities/pluralise';

export function useMetaData(
  name: string,
  market: PrimaryCountryISOElseGlobal,
  industry: string,
  totalRecords: number
) {
  const demonymCountry = getReadableCountry(market);
  const selectedIndustryItem = find(PRIMARY_INDUSTRIES, {
    slug: industry as PrimaryIndustrySlug,
  });

  const readableIndustryLabel = selectedIndustryItem
    ? selectedIndustryItem.label
    : 'Any';
  /**
   * Title
   */
  const title = `${demonymCountry}${
    readableIndustryLabel !== 'Any' ? ` ${readableIndustryLabel}` : ''
  } ${name}`;
  /**
   * Document Title
   */
  const documentTitle = `${totalRecords} ${demonymCountry}${
    readableIndustryLabel !== 'Any' ? ` ${readableIndustryLabel}` : ''
  } ${pluralise(totalRecords, 'Stock', 'Stocks')} - ${name} - Investing Ideas`;

  return {
    title,
    documentTitle,
    demonymCountry,
  };
}
